import AxionMultiLineText from "./AxionMultiLineText";
import AxionTextBox from "./AxionTextBox";
import AxionSelect from "./AxionSelect";
import AxionTextBoxReadOnly from "./AxionTextBoxReadOnly";
import AxionAutoComplete from "./AxionAutocomplete";
 
const AxionControls = {
  AxionMultiLineText,
  AxionTextBox,
  AxionSelect,
  AxionTextBoxReadOnly,
  AxionAutoComplete,
  
};
export default AxionControls;